import { render, staticRenderFns } from "./ScoreCalculator.vue?vue&type=template&id=3d599955&scoped=true&"
import script from "./ScoreCalculator.vue?vue&type=script&lang=js&"
export * from "./ScoreCalculator.vue?vue&type=script&lang=js&"
import style0 from "./ScoreCalculator.vue?vue&type=style&index=0&id=3d599955&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d599955",
  null
  
)

export default component.exports